module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms1.947ea9b45d1ef56496dcb2e030f4f059.png";